module.exports = __webpack_public_path__ + "static/img/camburg.ae929d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/buttons/camburg.png
// module id = ZCFA
// module chunks = 0